
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  detectRuntime,
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.10.2
 * Query Engine version: 5a9203d0590c951969e85a7d07215503f4672eb9
 */
Prisma.prismaVersion = {
  client: "5.10.2",
  engine: "5a9203d0590c951969e85a7d07215503f4672eb9"
}

Prisma.PrismaClientKnownRequestError = () => {
  throw new Error(`PrismaClientKnownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  throw new Error(`PrismaClientUnknownRequestError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  throw new Error(`PrismaClientRustPanicError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  throw new Error(`PrismaClientInitializationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  throw new Error(`PrismaClientValidationError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  throw new Error(`NotFoundError is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  throw new Error(`sqltag is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  throw new Error(`empty is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  throw new Error(`join is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  throw new Error(`raw is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  throw new Error(`Extensions.getExtensionContext is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  throw new Error(`Extensions.defineExtension is unable to be run ${runtimeDescription}.
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}

/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.LanguageScalarFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  email: 'email',
  emailVerified: 'emailVerified',
  firstName: 'firstName',
  lastName: 'lastName',
  password: 'password',
  phoneNumber: 'phoneNumber',
  secretKey: 'secretKey',
  role: 'role',
  isSubscribed: 'isSubscribed',
  createAt: 'createAt',
  updateAt: 'updateAt',
  travelGuideByLangId: 'travelGuideByLangId'
};

exports.Prisma.AccountScalarFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refreshToken: 'refreshToken',
  accessToken: 'accessToken',
  expiresAt: 'expiresAt',
  tokenType: 'tokenType',
  scope: 'scope',
  idToken: 'idToken',
  sessionState: 'sessionState'
};

exports.Prisma.VerificationTokenScalarFieldEnum = {
  id: 'id',
  email: 'email',
  token: 'token',
  expires: 'expires'
};

exports.Prisma.TextContentScalarFieldEnum = {
  id: 'id',
  trafic: 'trafic',
  pageMetaDataId: 'pageMetaDataId',
  createAt: 'createAt',
  updateAt: 'updateAt',
  typeId: 'typeId'
};

exports.Prisma.TextContentTypeScalarFieldEnum = {
  id: 'id',
  type: 'type',
  name: 'name'
};

exports.Prisma.UserOnContentByLangScalarFieldEnum = {
  contentByLangId: 'contentByLangId',
  userId: 'userId',
  createAt: 'createAt',
  updateAt: 'updateAt'
};

exports.Prisma.ContentByLangScalarFieldEnum = {
  id: 'id',
  textContentId: 'textContentId',
  languageId: 'languageId',
  title: 'title',
  desc: 'desc',
  content: 'content',
  bannerImg: 'bannerImg',
  bannerDesc: 'bannerDesc',
  thumbnail: 'thumbnail',
  status: 'status',
  faqs: 'faqs',
  traffic: 'traffic',
  regionId: 'regionId',
  createAt: 'createAt',
  updateAt: 'updateAt'
};

exports.Prisma.TextContentReviewScalarFieldEnum = {
  id: 'id',
  createAt: 'createAt',
  updateAt: 'updateAt',
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  review: 'review',
  textContentId: 'textContentId'
};

exports.Prisma.ReviewUsScalarFieldEnum = {
  id: 'id',
  createAt: 'createAt',
  updateAt: 'updateAt',
  review: 'review'
};

exports.Prisma.VIPPackageScalarFieldEnum = {
  id: 'id',
  name: 'name',
  price: 'price',
  desc: 'desc'
};

exports.Prisma.MembershipScalarFieldEnum = {
  userId: 'userId',
  vipPackageId: 'vipPackageId'
};

exports.Prisma.PageMetadataScalarFieldEnum = {
  id: 'id',
  name: 'name',
  url: 'url',
  type: 'type'
};

exports.Prisma.AlternatesLanguagesPageMetadataScalarFieldEnum = {
  id: 'id',
  url: 'url',
  pageId: 'pageId',
  languageId: 'languageId',
  title: 'title',
  description: 'description',
  generator: 'generator',
  applicationName: 'applicationName',
  referrer: 'referrer',
  creator: 'creator',
  publisher: 'publisher',
  JsonLD: 'JsonLD',
  category: 'category'
};

exports.Prisma.AlternatesLanguagesPageMetadataKeywordScalarFieldEnum = {
  id: 'id',
  keyword: 'keyword',
  alternatesLanguagesPageId: 'alternatesLanguagesPageId'
};

exports.Prisma.AlternatesLanguagesPageMetadataFormatDetectionScalarFieldEnum = {
  id: 'id',
  email: 'email',
  address: 'address',
  telephone: 'telephone'
};

exports.Prisma.AlternatesLanguagesPageMetadataOpenGraphScalarFieldEnum = {
  id: 'id',
  title: 'title',
  description: 'description',
  url: 'url',
  siteName: 'siteName',
  locale: 'locale',
  type: 'type',
  publishedTime: 'publishedTime'
};

exports.Prisma.AlternatesLanguagesPageMetadataOpenGraphImageScalarFieldEnum = {
  id: 'id',
  url: 'url',
  width: 'width',
  height: 'height',
  alt: 'alt',
  alternatesLanguagesPageOpenGraphId: 'alternatesLanguagesPageOpenGraphId'
};

exports.Prisma.AlternatesLanguagesPageMetadataRobotsScalarFieldEnum = {
  id: 'id',
  index: 'index',
  follow: 'follow',
  nocache: 'nocache',
  googleBotIndex: 'googleBotIndex',
  googleBotFollow: 'googleBotFollow',
  googleBotNoimageindex: 'googleBotNoimageindex',
  googleBotMaxVideoPreview: 'googleBotMaxVideoPreview',
  googleBotMaxImagePreview: 'googleBotMaxImagePreview',
  googleBotMaxSnippet: 'googleBotMaxSnippet'
};

exports.Prisma.AlternatesLanguagesPageMetadataTwitterScalarFieldEnum = {
  id: 'id',
  card: 'card',
  title: 'title',
  description: 'description',
  siteId: 'siteId',
  creator: 'creator',
  creatorId: 'creatorId'
};

exports.Prisma.AlternatesLanguagesPageMetadataTwitterImageScalarFieldEnum = {
  id: 'id',
  url: 'url',
  alt: 'alt',
  alternatesLanguagesPageMetadataTwitterId: 'alternatesLanguagesPageMetadataTwitterId'
};

exports.Prisma.CloudFlareFileScalarFieldEnum = {
  id: 'id',
  filename: 'filename',
  uploaded: 'uploaded',
  requireSignedURLs: 'requireSignedURLs',
  authorId: 'authorId'
};

exports.Prisma.CloudFlareFilesOnTravelGuidesScalarFieldEnum = {
  id: 'id',
  cloudFlareFileId: 'cloudFlareFileId',
  travelGuideId: 'travelGuideId'
};

exports.Prisma.TravelGuideScalarFieldEnum = {
  id: 'id',
  pageMetaDataId: 'pageMetaDataId',
  trafic: 'trafic',
  regionId: 'regionId',
  createAt: 'createAt',
  updateAt: 'updateAt'
};

exports.Prisma.TravelGuideByLangScalarFieldEnum = {
  id: 'id',
  visit31TravelGuideTitle: 'visit31TravelGuideTitle',
  visit31TravelGuideDesc: 'visit31TravelGuideDesc',
  visit31TravelGuideTitle2: 'visit31TravelGuideTitle2',
  visit31TravelGuideDesc2: 'visit31TravelGuideDesc2',
  visit31TravelGuideImageId: 'visit31TravelGuideImageId',
  travelEssentialsSectionTitle: 'travelEssentialsSectionTitle',
  travelEssentialsSectionDesc: 'travelEssentialsSectionDesc',
  exploreSectionTitle: 'exploreSectionTitle',
  exploreSectionDesc: 'exploreSectionDesc',
  languageId: 'languageId',
  travelGuideId: 'travelGuideId',
  status: 'status',
  createAt: 'createAt',
  updateAt: 'updateAt'
};

exports.Prisma.TravelEssentialsSectionChildWidgetScalarFieldEnum = {
  id: 'id',
  title: 'title',
  desc: 'desc',
  link: 'link',
  imageId: 'imageId',
  travelGuideByLangId: 'travelGuideByLangId'
};

exports.Prisma.ActivityScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createAt: 'createAt',
  updateAt: 'updateAt'
};

exports.Prisma.ActivitiesOnTravelGuidesScalarFieldEnum = {
  id: 'id',
  travelGuideId: 'travelGuideId',
  activityId: 'activityId'
};

exports.Prisma.ActivitiesOnContentByLangsScalarFieldEnum = {
  id: 'id',
  contentByLangId: 'contentByLangId',
  activityId: 'activityId'
};

exports.Prisma.RegionScalarFieldEnum = {
  id: 'id',
  region: 'region',
  city: 'city',
  country: 'country',
  continent: 'continent',
  iso2: 'iso2',
  preferCountry: 'preferCountry',
  gmtTimezone: 'gmtTimezone'
};

exports.Prisma.TagScalarFieldEnum = {
  id: 'id',
  name: 'name',
  createAt: 'createAt',
  updateAt: 'updateAt'
};

exports.Prisma.TagsOnTravelGuidesScalarFieldEnum = {
  id: 'id',
  travelGuideId: 'travelGuideId',
  tagId: 'tagId'
};

exports.Prisma.TagsOnContentByLangScalarFieldEnum = {
  id: 'id',
  contentByLangId: 'contentByLangId',
  tagId: 'tagId'
};

exports.Prisma.AirportTransferScalarFieldEnum = {
  id: 'id',
  title: 'title',
  desc: 'desc',
  thumbnail: 'thumbnail',
  name: 'name',
  placeId: 'placeId',
  formattedAddress: 'formattedAddress',
  longitude: 'longitude',
  latitude: 'latitude',
  continent: 'continent',
  contentId: 'contentId',
  createAt: 'createAt',
  updateAt: 'updateAt'
};

exports.Prisma.JourneyFormAirportTransferScalarFieldEnum = {
  id: 'id',
  from: 'from',
  to: 'to',
  toAddress: 'toAddress',
  toLatitude: 'toLatitude',
  toLongitude: 'toLongitude',
  estimatedTime: 'estimatedTime',
  estimatedDistance: 'estimatedDistance',
  startFee: 'startFee',
  description: 'description',
  airportTransferId: 'airportTransferId',
  createAt: 'createAt',
  updateAt: 'updateAt'
};

exports.Prisma.FnqScalarFieldEnum = {
  id: 'id',
  question: 'question',
  answer: 'answer',
  airportTransferId: 'airportTransferId',
  createAt: 'createAt',
  updateAt: 'updateAt'
};

exports.Prisma.AirportTransferCommentScalarFieldEnum = {
  id: 'id',
  comment: 'comment',
  username: 'username',
  country: 'country',
  avatar: 'avatar',
  airportTransferId: 'airportTransferId',
  createAt: 'createAt',
  updateAt: 'updateAt'
};

exports.Prisma.AirportTransferCTAScalarFieldEnum = {
  id: 'id',
  title: 'title',
  link: 'link',
  airportTransferId: 'airportTransferId',
  createAt: 'createAt',
  updateAt: 'updateAt'
};

exports.Prisma.AirportTransferWhyUsScalarFieldEnum = {
  id: 'id',
  title: 'title',
  desc: 'desc',
  airportTransferId: 'airportTransferId',
  createAt: 'createAt',
  updateAt: 'updateAt'
};

exports.Prisma.FormScalarFieldEnum = {
  id: 'id',
  title: 'title',
  createAt: 'createAt',
  updateAt: 'updateAt',
  isDelete: 'isDelete'
};

exports.Prisma.FormByLangScalarFieldEnum = {
  id: 'id',
  formType: 'formType',
  createAt: 'createAt',
  updateAt: 'updateAt',
  languageId: 'languageId',
  formId: 'formId'
};

exports.Prisma.FieldScalarFieldEnum = {
  id: 'id',
  label: 'label',
  position: 'position',
  type: 'type',
  require: 'require',
  isDelete: 'isDelete',
  formByLangId: 'formByLangId'
};

exports.Prisma.PropertyFieldScalarFieldEnum = {
  id: 'id',
  description: 'description',
  position: 'position',
  isDelete: 'isDelete',
  fieldId: 'fieldId'
};

exports.Prisma.ResponseFormScalarFieldEnum = {
  id: 'id',
  createAt: 'createAt',
  title: 'title',
  formByLangId: 'formByLangId'
};

exports.Prisma.ResponseFieldScalarFieldEnum = {
  id: 'id',
  value: 'value',
  propertyFieldId: 'propertyFieldId',
  fieldId: 'fieldId',
  responseFormId: 'responseFormId'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.QueryMode = {
  default: 'default',
  insensitive: 'insensitive'
};

exports.Prisma.LanguageOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};

exports.Prisma.UserOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  firstName: 'firstName',
  lastName: 'lastName',
  password: 'password',
  phoneNumber: 'phoneNumber',
  secretKey: 'secretKey',
  travelGuideByLangId: 'travelGuideByLangId'
};

exports.Prisma.AccountOrderByRelevanceFieldEnum = {
  id: 'id',
  userId: 'userId',
  type: 'type',
  provider: 'provider',
  providerAccountId: 'providerAccountId',
  refreshToken: 'refreshToken',
  accessToken: 'accessToken',
  tokenType: 'tokenType',
  scope: 'scope',
  idToken: 'idToken',
  sessionState: 'sessionState'
};

exports.Prisma.VerificationTokenOrderByRelevanceFieldEnum = {
  id: 'id',
  email: 'email',
  token: 'token'
};

exports.Prisma.TextContentOrderByRelevanceFieldEnum = {
  id: 'id',
  pageMetaDataId: 'pageMetaDataId'
};

exports.Prisma.TextContentTypeOrderByRelevanceFieldEnum = {
  type: 'type',
  name: 'name'
};

exports.Prisma.UserOnContentByLangOrderByRelevanceFieldEnum = {
  contentByLangId: 'contentByLangId',
  userId: 'userId'
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.ContentByLangOrderByRelevanceFieldEnum = {
  id: 'id',
  textContentId: 'textContentId',
  languageId: 'languageId',
  title: 'title',
  desc: 'desc',
  content: 'content',
  bannerImg: 'bannerImg',
  bannerDesc: 'bannerDesc',
  thumbnail: 'thumbnail',
  regionId: 'regionId'
};

exports.Prisma.TextContentReviewOrderByRelevanceFieldEnum = {
  firstName: 'firstName',
  lastName: 'lastName',
  email: 'email',
  review: 'review',
  textContentId: 'textContentId'
};

exports.Prisma.ReviewUsOrderByRelevanceFieldEnum = {
  review: 'review'
};

exports.Prisma.VIPPackageOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  desc: 'desc'
};

exports.Prisma.MembershipOrderByRelevanceFieldEnum = {
  userId: 'userId',
  vipPackageId: 'vipPackageId'
};

exports.Prisma.PageMetadataOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name',
  url: 'url'
};

exports.Prisma.AlternatesLanguagesPageMetadataOrderByRelevanceFieldEnum = {
  id: 'id',
  url: 'url',
  pageId: 'pageId',
  languageId: 'languageId',
  title: 'title',
  description: 'description',
  generator: 'generator',
  applicationName: 'applicationName',
  referrer: 'referrer',
  creator: 'creator',
  publisher: 'publisher',
  category: 'category'
};

exports.Prisma.AlternatesLanguagesPageMetadataKeywordOrderByRelevanceFieldEnum = {
  id: 'id',
  keyword: 'keyword',
  alternatesLanguagesPageId: 'alternatesLanguagesPageId'
};

exports.Prisma.AlternatesLanguagesPageMetadataFormatDetectionOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.AlternatesLanguagesPageMetadataOpenGraphOrderByRelevanceFieldEnum = {
  id: 'id',
  title: 'title',
  description: 'description',
  url: 'url',
  siteName: 'siteName',
  locale: 'locale',
  type: 'type'
};

exports.Prisma.AlternatesLanguagesPageMetadataOpenGraphImageOrderByRelevanceFieldEnum = {
  id: 'id',
  url: 'url',
  alt: 'alt',
  alternatesLanguagesPageOpenGraphId: 'alternatesLanguagesPageOpenGraphId'
};

exports.Prisma.AlternatesLanguagesPageMetadataRobotsOrderByRelevanceFieldEnum = {
  id: 'id'
};

exports.Prisma.AlternatesLanguagesPageMetadataTwitterOrderByRelevanceFieldEnum = {
  id: 'id',
  card: 'card',
  title: 'title',
  description: 'description',
  siteId: 'siteId',
  creator: 'creator',
  creatorId: 'creatorId'
};

exports.Prisma.AlternatesLanguagesPageMetadataTwitterImageOrderByRelevanceFieldEnum = {
  id: 'id',
  url: 'url',
  alt: 'alt',
  alternatesLanguagesPageMetadataTwitterId: 'alternatesLanguagesPageMetadataTwitterId'
};

exports.Prisma.CloudFlareFileOrderByRelevanceFieldEnum = {
  id: 'id',
  filename: 'filename',
  authorId: 'authorId'
};

exports.Prisma.CloudFlareFilesOnTravelGuidesOrderByRelevanceFieldEnum = {
  id: 'id',
  cloudFlareFileId: 'cloudFlareFileId',
  travelGuideId: 'travelGuideId'
};

exports.Prisma.TravelGuideOrderByRelevanceFieldEnum = {
  id: 'id',
  pageMetaDataId: 'pageMetaDataId',
  regionId: 'regionId'
};

exports.Prisma.TravelGuideByLangOrderByRelevanceFieldEnum = {
  id: 'id',
  visit31TravelGuideTitle: 'visit31TravelGuideTitle',
  visit31TravelGuideDesc: 'visit31TravelGuideDesc',
  visit31TravelGuideTitle2: 'visit31TravelGuideTitle2',
  visit31TravelGuideDesc2: 'visit31TravelGuideDesc2',
  visit31TravelGuideImageId: 'visit31TravelGuideImageId',
  travelEssentialsSectionTitle: 'travelEssentialsSectionTitle',
  travelEssentialsSectionDesc: 'travelEssentialsSectionDesc',
  exploreSectionTitle: 'exploreSectionTitle',
  exploreSectionDesc: 'exploreSectionDesc',
  languageId: 'languageId',
  travelGuideId: 'travelGuideId'
};

exports.Prisma.TravelEssentialsSectionChildWidgetOrderByRelevanceFieldEnum = {
  id: 'id',
  title: 'title',
  desc: 'desc',
  link: 'link',
  imageId: 'imageId',
  travelGuideByLangId: 'travelGuideByLangId'
};

exports.Prisma.ActivityOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.ActivitiesOnTravelGuidesOrderByRelevanceFieldEnum = {
  id: 'id',
  travelGuideId: 'travelGuideId',
  activityId: 'activityId'
};

exports.Prisma.ActivitiesOnContentByLangsOrderByRelevanceFieldEnum = {
  id: 'id',
  contentByLangId: 'contentByLangId',
  activityId: 'activityId'
};

exports.Prisma.RegionOrderByRelevanceFieldEnum = {
  id: 'id',
  region: 'region',
  city: 'city',
  country: 'country',
  continent: 'continent',
  iso2: 'iso2',
  preferCountry: 'preferCountry',
  gmtTimezone: 'gmtTimezone'
};

exports.Prisma.TagOrderByRelevanceFieldEnum = {
  id: 'id',
  name: 'name'
};

exports.Prisma.TagsOnTravelGuidesOrderByRelevanceFieldEnum = {
  id: 'id',
  travelGuideId: 'travelGuideId',
  tagId: 'tagId'
};

exports.Prisma.TagsOnContentByLangOrderByRelevanceFieldEnum = {
  id: 'id',
  contentByLangId: 'contentByLangId',
  tagId: 'tagId'
};

exports.Prisma.AirportTransferOrderByRelevanceFieldEnum = {
  id: 'id',
  title: 'title',
  desc: 'desc',
  thumbnail: 'thumbnail',
  name: 'name',
  placeId: 'placeId',
  formattedAddress: 'formattedAddress',
  contentId: 'contentId'
};

exports.Prisma.JourneyFormAirportTransferOrderByRelevanceFieldEnum = {
  id: 'id',
  from: 'from',
  to: 'to',
  toAddress: 'toAddress',
  estimatedTime: 'estimatedTime',
  estimatedDistance: 'estimatedDistance',
  startFee: 'startFee',
  description: 'description',
  airportTransferId: 'airportTransferId'
};

exports.Prisma.FnqOrderByRelevanceFieldEnum = {
  id: 'id',
  question: 'question',
  answer: 'answer',
  airportTransferId: 'airportTransferId'
};

exports.Prisma.AirportTransferCommentOrderByRelevanceFieldEnum = {
  id: 'id',
  comment: 'comment',
  username: 'username',
  country: 'country',
  avatar: 'avatar',
  airportTransferId: 'airportTransferId'
};

exports.Prisma.AirportTransferCTAOrderByRelevanceFieldEnum = {
  id: 'id',
  title: 'title',
  link: 'link',
  airportTransferId: 'airportTransferId'
};

exports.Prisma.AirportTransferWhyUsOrderByRelevanceFieldEnum = {
  id: 'id',
  title: 'title',
  desc: 'desc',
  airportTransferId: 'airportTransferId'
};

exports.Prisma.FormOrderByRelevanceFieldEnum = {
  id: 'id',
  title: 'title'
};

exports.Prisma.FormByLangOrderByRelevanceFieldEnum = {
  id: 'id',
  formType: 'formType',
  languageId: 'languageId',
  formId: 'formId'
};

exports.Prisma.FieldOrderByRelevanceFieldEnum = {
  id: 'id',
  label: 'label',
  type: 'type',
  formByLangId: 'formByLangId'
};

exports.Prisma.PropertyFieldOrderByRelevanceFieldEnum = {
  id: 'id',
  description: 'description',
  fieldId: 'fieldId'
};

exports.Prisma.ResponseFormOrderByRelevanceFieldEnum = {
  id: 'id',
  title: 'title',
  formByLangId: 'formByLangId'
};

exports.Prisma.ResponseFieldOrderByRelevanceFieldEnum = {
  id: 'id',
  value: 'value',
  propertyFieldId: 'propertyFieldId',
  fieldId: 'fieldId',
  responseFormId: 'responseFormId'
};
exports.UserRole = exports.$Enums.UserRole = {
  ROOT: 'ROOT',
  ADMIN: 'ADMIN',
  USER: 'USER',
  CLIENT: 'CLIENT'
};

exports.ContentStatus = exports.$Enums.ContentStatus = {
  DRAFT: 'DRAFT',
  PUBLIC: 'PUBLIC',
  HIDDEN: 'HIDDEN'
};

exports.PageMetadataType = exports.$Enums.PageMetadataType = {
  FIXED_PAGE: 'FIXED_PAGE',
  POST: 'POST',
  TRAVEL_GUIDES: 'TRAVEL_GUIDES'
};

exports.MaxImagePreview = exports.$Enums.MaxImagePreview = {
  none: 'none',
  standard: 'standard',
  large: 'large'
};

exports.Continent = exports.$Enums.Continent = {
  ASIA: 'ASIA',
  EUROPE: 'EUROPE',
  AMERICA: 'AMERICA',
  AFRICA: 'AFRICA',
  OCEANIA: 'OCEANIA'
};

exports.Prisma.ModelName = {
  Language: 'Language',
  User: 'User',
  Account: 'Account',
  VerificationToken: 'VerificationToken',
  TextContent: 'TextContent',
  TextContentType: 'TextContentType',
  UserOnContentByLang: 'UserOnContentByLang',
  ContentByLang: 'ContentByLang',
  TextContentReview: 'TextContentReview',
  ReviewUs: 'ReviewUs',
  VIPPackage: 'VIPPackage',
  Membership: 'Membership',
  PageMetadata: 'PageMetadata',
  AlternatesLanguagesPageMetadata: 'AlternatesLanguagesPageMetadata',
  AlternatesLanguagesPageMetadataKeyword: 'AlternatesLanguagesPageMetadataKeyword',
  AlternatesLanguagesPageMetadataFormatDetection: 'AlternatesLanguagesPageMetadataFormatDetection',
  AlternatesLanguagesPageMetadataOpenGraph: 'AlternatesLanguagesPageMetadataOpenGraph',
  AlternatesLanguagesPageMetadataOpenGraphImage: 'AlternatesLanguagesPageMetadataOpenGraphImage',
  AlternatesLanguagesPageMetadataRobots: 'AlternatesLanguagesPageMetadataRobots',
  AlternatesLanguagesPageMetadataTwitter: 'AlternatesLanguagesPageMetadataTwitter',
  AlternatesLanguagesPageMetadataTwitterImage: 'AlternatesLanguagesPageMetadataTwitterImage',
  CloudFlareFile: 'CloudFlareFile',
  CloudFlareFilesOnTravelGuides: 'CloudFlareFilesOnTravelGuides',
  TravelGuide: 'TravelGuide',
  TravelGuideByLang: 'TravelGuideByLang',
  TravelEssentialsSectionChildWidget: 'TravelEssentialsSectionChildWidget',
  Activity: 'Activity',
  ActivitiesOnTravelGuides: 'ActivitiesOnTravelGuides',
  ActivitiesOnContentByLangs: 'ActivitiesOnContentByLangs',
  Region: 'Region',
  Tag: 'Tag',
  TagsOnTravelGuides: 'TagsOnTravelGuides',
  TagsOnContentByLang: 'TagsOnContentByLang',
  AirportTransfer: 'AirportTransfer',
  JourneyFormAirportTransfer: 'JourneyFormAirportTransfer',
  Fnq: 'Fnq',
  AirportTransferComment: 'AirportTransferComment',
  AirportTransferCTA: 'AirportTransferCTA',
  AirportTransferWhyUs: 'AirportTransferWhyUs',
  Form: 'Form',
  FormByLang: 'FormByLang',
  Field: 'Field',
  PropertyField: 'PropertyField',
  ResponseForm: 'ResponseForm',
  ResponseField: 'ResponseField'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        const runtime = detectRuntime()
        const edgeRuntimeName = {
          'workerd': 'Cloudflare Workers',
          'deno': 'Deno and Deno Deploy',
          'netlify': 'Netlify Edge Functions',
          'edge-light': 'Vercel Edge Functions or Edge Middleware',
        }[runtime]

        let message = 'PrismaClient is unable to run in '
        if (edgeRuntimeName !== undefined) {
          message += edgeRuntimeName + '. As an alternative, try Accelerate: https://pris.ly/d/accelerate.'
        } else {
          message += 'this browser environment, or has been bundled for the browser (running in `' + runtime + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
